import { create } from 'zustand';
import type { CompleteUser } from '../types';
import { authService } from '../services/auth/auth.service';

interface AuthState {
  user: CompleteUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  
  // Actions
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  loadUser: () => Promise<void>;
  setUser: (user: CompleteUser | null) => void;
  setLoading: (loading: boolean) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isLoading: false,
  isAuthenticated: false,

  login: async (email: string, password: string) => {
    try {
      set({ isLoading: true });
      
      const loginResponse = await authService.login({ email, password });
      
      // Usar el usuario completo de la respuesta del login
      set({ 
        user: loginResponse.usuario, 
        isAuthenticated: true,
        isLoading: false 
      });
    } catch (error) {
      set({ isLoading: false });
      throw error;
    }
  },

  logout: async () => {
    try {
      await authService.logout();
    } finally {
      set({ 
        user: null, 
        isAuthenticated: false,
        isLoading: false 
      });
    }
  },

  loadUser: async () => {
    if (!authService.isAuthenticated()) {
      set({ isAuthenticated: false, isLoading: false });
      return;
    }

    try {
      set({ isLoading: true });
      const user = await authService.getCurrentUser();
      
      set({ 
        user, 
        isAuthenticated: true,
        isLoading: false 
      });
    } catch (error) {
      set({ 
        user: null, 
        isAuthenticated: false,
        isLoading: false 
      });
      throw error;
    }
  },

  setUser: (user: CompleteUser | null) => {
    set({ 
      user, 
      isAuthenticated: !!user 
    });
  },

  setLoading: (loading: boolean) => {
    set({ isLoading: loading });
  },
}));